// extracted by mini-css-extract-plugin
export default {"preview-chapter-modal":"PreviewChapterModal_preview-chapter-modal__bCKLY","header-wrapper":"PreviewChapterModal_header-wrapper__2DCNY","content":"PreviewChapterModal_content__9UEF0"};